import { useCallback } from 'react';
import { addons } from '@storybook/addons';
import { useStoryContext } from '@storybook/client-api';
import { UPDATE_STORY_ARGS } from '@storybook/core-events';

// копипаста https://github.com/storybookjs/storybook/blob/v6.3.9/lib/addons/src/hooks.ts#L408-L423,
// потому что оригинальный useArgs падает с React Error: Rendered fewer hooks than expected
export const useArgs = () => {
    const channel = addons.getChannel();
    const { id: storyId, args } = useStoryContext();

    const updateArgs = useCallback(
        (updatedArgs) => channel.emit(UPDATE_STORY_ARGS, { storyId, updatedArgs }),
        [channel, storyId]
    );

    const resetArgs = useCallback(
        (argNames) => channel.emit(RESET_STORY_ARGS, { storyId, argNames }),
        [channel, storyId]
    );

    return [args, updateArgs, resetArgs];
};

export default {};
